import React from 'react';
import { Section } from './ui/Section';
import { ClockIcon } from 'lucide-react';
export const Problem = () => {
  return <Section className="bg-white" data-id="element-149">
      <div className="max-w-3xl mx-auto" data-id="element-150">
        <div className="flex items-center gap-3 text-terracotta mb-6" data-id="element-151">
          <ClockIcon size={24} data-id="element-152" />
          <span className="font-serif text-xl italic" data-id="element-153">El Escenario Diario</span>
        </div>

        <p className="text-xl md:text-2xl leading-relaxed text-charcoal font-medium mb-12" data-id="element-154">
          Son las 7:45 de la mañana. Los zapatos no aparecen, el desayuno se
          enfría y tu hijo parece ignorar cada palabra que dices. Sientes ese
          calor subiendo por tu cuello y, antes de que puedas evitarlo, el grito
          sale.{' '}
          <span className="bg-beige/50 px-1" data-id="element-155">
            El silencio que sigue es peor que el caos: es el silencio de la
            culpa.
          </span>{' '}
          No eres una mala madre, eres una madre agotada.
        </p>

        <div className="h-px w-full bg-border my-12" data-id="element-156"></div>

        <h3 className="text-2xl md:text-3xl font-serif font-semibold mb-6 text-charcoal" data-id="element-157">
          La Realidad de Criar en USA
        </h3>

        <div className="space-y-6 text-lg text-charcoal/80 leading-relaxed font-light" data-id="element-158">
          <p data-id="element-159">
            En este país, criar es un deporte de alto rendimiento. Trabajamos
            jornadas largas, manejamos distancias eternas bajo presión y, a
            diferencia de nuestros países, aquí no tenemos a la abuela o a la
            tía para darnos un respiro.
          </p>
          <p data-id="element-160">
            Ese aislamiento hace que tu sistema nervioso viva en modo
            "supervivencia". Cuando tu hijo no obedece, tu cerebro lo procesa
            como una amenaza más, y tu única herramienta de defensa termina
            siendo el grito.
          </p>
          <p className="font-medium text-charcoal" data-id="element-161">
            Pero el grito no educa; solo te aleja de ellos y te deja un vacío en
            el pecho al final del día.
          </p>
        </div>
      </div>
    </Section>;
};